import { render, staticRenderFns } from "./TituloFormularioInstituicaoEnsino.vue?vue&type=template&id=464a68f5&"
import script from "./TituloFormularioInstituicaoEnsino.vue?vue&type=script&lang=js&"
export * from "./TituloFormularioInstituicaoEnsino.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports